import { useState, useEffect } from "react";
import LineChart from "../../charts/LineChart01";
import Icon from "../../images/icon-01.svg";
// import EditMenu from "../EditMenu";
import { GiFarmer } from "react-icons/gi";
import { GiPlantRoots } from "react-icons/gi";
import { HiOutlineUsers } from "react-icons/hi";
import { GiToken } from "react-icons/gi";
import { MdOutlineGeneratingTokens } from "react-icons/md";
import { AiOutlineTransaction, AiFillDollarCircle } from "react-icons/ai";
import { BiCoinStack } from "react-icons/bi";
import { FaCoins } from "react-icons/fa";
import millify from "millify";
import GreenLogo from "../../images/Carbo-X-Green.svg";
import BlueLogo from "../../images/Carbo-X-Blue.svg";

// Import utilities
import { tailwindConfig, hexToRGB } from "../../utils/Utils";
import axios from "axios";
import { toast } from "react-toastify";
import { baseUrl } from "../../utils/Utils";
import useBreakpoint from "../../utils/useBreakpoint";
import { useSelector } from "react-redux";
import { ethers } from "ethers";
import Skeleton from "./Skeleton";

function Stat1() {
  const [farmData, setFarmData] = useState([]);
  const [plotData, setPlotData] = useState([]);
  const [farmersData, setFarmersData] = useState([]);
  const [usersData, setUsersData] = useState([]);
  const [greenTokenDetails, setGreenTokenDetails] = useState({
    name: "N/A",
    symbol: "N/A",
    tokensAvailable: "N/A",
    tokenPrice: "N/A",
    circulating: "N/A",
    totalTokens: "N/A",
  });
  const [blueTokenDetails, setBlueTokenDetails] = useState({
    name: "N/A",
    symbol: "N/A",
    tokensAvailable: "N/A",
    tokenPrice: "N/A",
    circulating: "N/A",
    totalTokens: "N/A",
  });

  const { isMobile, isTable } = useBreakpoint();

  const isLoggedIn = useSelector((state) => state?.auth?.isLoggedIn);

  const { user } = useSelector((state) => state.auth);
  const contractsData = useSelector((state) => state?.auth?.contracts);

  const getTokenDetails = async () => {
    console.log("function called");
    if (user?.signer) {
      let blueDetails = {
        name: await contractsData?.blueToken.name(),
        symbol: await contractsData?.blueToken.symbol(),
        tokensAvailable: ethers.utils.formatEther(
          (await contractsData?.blueToken.balanceOf(user?.signer)) || "0"
        ),
        tokenPrice: "N/A",
        circulating: millify(
          ethers.utils.formatEther(
            (await contractsData?.blueToken.totalSupply()) || "0"
          )
        ),
        totalTokens: millify(
          ethers.utils.formatEther(
            (await contractsData?.blueToken.totalSupply()) || "0"
          )
        ),
      };
      setBlueTokenDetails(blueDetails);
      let greenDetails = {
        name: await contractsData?.greenToken.name(),
        symbol: await contractsData?.greenToken.symbol(),
        tokensAvailable: ethers.utils.formatEther(
          (await contractsData?.greenToken.balanceOf(user?.signer)) || "0"
        ),
        tokenPrice: "N/A",
        circulating: ethers.utils.formatEther(
          (await contractsData?.greenToken.totalSupply()) || "0"
        ),
        totalTokens: `∞`,
      };
      setGreenTokenDetails(greenDetails);
    }
  };

  useEffect(() => {
    if (user?.signer) {
      getTokenDetails();
    }
  }, [user?.signer, contractsData]);

  console.log(greenTokenDetails, blueTokenDetails);

  return (
    <div className="stats-group">
      <div className="stats-card shadow-card green-radial-hue">
        <div className="img-wrapper">
          <img src={GreenLogo} alt="" />
        </div>
        <div className="content-wrapper">
          <h4 className="green-text">Carbo-X Green</h4>
          <div className="inner-wrapper">
            <div className="token-wrapper">
              <p>Token Price</p>
              <h5 className="main-token green-text">
                {greenTokenDetails.tokenPrice !== "N/A" ? (
                  <div>
                    {greenTokenDetails?.tokenPrice &&
                      greenTokenDetails.tokenPrice}
                    <span className="mt-4 ml-1">
                      {" "}
                      {greenTokenDetails?.symbol && greenTokenDetails.symbol}
                    </span>
                  </div>
                ) : (
                  <Skeleton height={"h-[10px] mt-[22px]"} width="w-[100%]" />
                )}
              </h5>
            </div>
            <div className="token-wrapper">
              <p>Tokens Available</p>
              <h5>
                {greenTokenDetails.tokensAvailable !== "N/A" ? (
                  <div>
                    {greenTokenDetails?.tokensAvailable &&
                      greenTokenDetails.tokensAvailable}
                    <span className="mt-4 ml-1">
                      {" "}
                      {greenTokenDetails?.symbol && greenTokenDetails.symbol}
                    </span>
                  </div>
                ) : (
                  <Skeleton height={"h-[10px]"} width="w-[100%]" />
                )}
              </h5>
            </div>
            <div className="token-wrapper">
              <p>Circulating Supply</p>
              <h5>
                {greenTokenDetails.circulating !== "N/A" ? (
                  <div>
                    {greenTokenDetails?.circulating &&
                      greenTokenDetails.circulating}
                    <span className="mt-4 ml-1">
                      {" "}
                      {greenTokenDetails?.symbol && greenTokenDetails.symbol}
                    </span>
                  </div>
                ) : (
                  <Skeleton height={"h-[10px]"} width="w-[100%]" />
                )}
              </h5>
            </div>
            <div className="token-wrapper">
              <p>Total Tokens</p>
              <h5>
                {greenTokenDetails.totalTokens !== "N/A" ? (
                  <div>
                    {greenTokenDetails?.totalTokens &&
                      greenTokenDetails.totalTokens}
                    <span className="mt-4 ml-1">
                      {" "}
                      {greenTokenDetails?.symbol && greenTokenDetails.symbol}
                    </span>
                  </div>
                ) : (
                  <Skeleton height={"h-[10px]"} width="w-[100%]" />
                )}
              </h5>
            </div>
          </div>
        </div>
      </div>

      <div className="stats-card shadow-card blue-radial-hue">
        <div className="img-wrapper">
          <img src={BlueLogo} alt="" />
        </div>
        <div className="content-wrapper">
          <h4 className="blue-text">Carbo-X Blue</h4>
          <div className="inner-wrapper">
            <div className="token-wrapper">
              <p>Token Price</p>
              <h5 className="main-token blue-text">
                {blueTokenDetails.tokenPrice !== "N/A" ? (
                  <div>
                    {blueTokenDetails?.tokenPrice &&
                      blueTokenDetails.tokenPrice}
                    <span className="mt-4 ml-1">
                      {" "}
                      {blueTokenDetails?.symbol && blueTokenDetails.symbol}
                    </span>
                  </div>
                ) : (
                  <Skeleton height={"h-[10px] mt-[22px]"} width="w-[100%]" />
                )}
              </h5>
            </div>
            <div className="token-wrapper">
              <p>Tokens Available</p>
              <h5>
                {blueTokenDetails.tokensAvailable !== "N/A" ? (
                  <div>
                    {blueTokenDetails?.tokensAvailable &&
                      blueTokenDetails.tokensAvailable}
                    <span className="mt-4 ml-1">
                      {" "}
                      {blueTokenDetails?.symbol && blueTokenDetails.symbol}
                    </span>
                  </div>
                ) : (
                  <Skeleton height={"h-[10px]"} width="w-[100%]" />
                )}
              </h5>
            </div>
            <div className="token-wrapper">
              <p>Circulating Supply</p>
              <h5>
                {blueTokenDetails.circulating !== "N/A" ? (
                  <div>
                    {blueTokenDetails?.circulating &&
                      blueTokenDetails.circulating}
                    <span className="mt-4 ml-1">
                      {" "}
                      {blueTokenDetails?.symbol && blueTokenDetails.symbol}
                    </span>
                  </div>
                ) : (
                  <Skeleton height={"h-[10px]"} width="w-[100%]" />
                )}
              </h5>
            </div>
            <div className="token-wrapper">
              <p>Total Tokens</p>
              <h5>
                {blueTokenDetails.totalTokens !== "N/A" ? (
                  <div>
                    {blueTokenDetails?.totalTokens &&
                      blueTokenDetails.totalTokens}
                    <span className="mt-4 ml-1">
                      {" "}
                      {blueTokenDetails?.symbol && blueTokenDetails.symbol}
                    </span>
                  </div>
                ) : (
                  <Skeleton height={"h-[10px]"} width="w-[100%]" />
                )}
              </h5>
            </div>
          </div>
        </div>
      </div>

      <div
        style={
          {display: 'none'}
        }
        className="bg-white shadow-lg mb-5 rounded-3xl border border-slate-200 px-5 pt-5"
      >
        <h2
          className={
            isMobile
              ? "text-lg text-center mt-5 font-semibold text-gray-500 text-slate-800 mb-2"
              : "text-lg mt-5 font-semibold text-gray-500 text-slate-800 mb-2"
          }
        >
          Tokens Available
        </h2>
        <div
          className={
            isMobile ? "flex items-center justify-center" : "flex items-start"
          }
        >
          <div className="flex">
            {greenTokenDetails.tokensAvailable !== "N/A" ? (
              <div className="text-4xl flex font-bold text-slate-800 mr-2">
                <FaCoins
                  style={{
                    backgroundImage:
                      "linear-gradient(120deg, #d4fc79 0%, #96e6a1 100%)",
                    width: "45px",
                    height: "45px",
                    padding: "6px",
                    borderRadius: "15px",
                  }}
                  className="text-green-800"
                />{" "}
                <span className="ml-6">
                  {greenTokenDetails.tokensAvailable &&
                    greenTokenDetails.tokensAvailable}
                </span>
                <span className="text-lg mt-4 ml-1">
                  {" "}
                  {greenTokenDetails.symbol && greenTokenDetails.symbol}
                </span>
              </div>
            ) : (
              <Skeleton />
            )}

            {blueTokenDetails.tokensAvailable !== "N/A" ? (
              <div className="text-4xl flex font-bold ml-4 text-slate-800 mr-2">
                <FaCoins
                  style={{
                    backgroundImage:
                      "linear-gradient(120deg, #83EAF1 0%, #63A4FF 100%)",
                    width: "45px",
                    height: "45px",
                    padding: "6px",
                    borderRadius: "15px",
                  }}
                  className="text-blue-800"
                />{" "}
                <span className="ml-6">
                  {blueTokenDetails.tokensAvailable &&
                    blueTokenDetails.tokensAvailable}
                </span>
                <span className="text-lg mt-4 ml-1">
                  {" "}
                  {blueTokenDetails.symbol && blueTokenDetails.symbol}
                </span>
              </div>
            ) : (
              <div className="ml-4">
                <Skeleton />
              </div>
            )}
          </div>
        </div>
        <h2
          className={
            isMobile
              ? "text-lg text-center mt-5 font-semibold text-gray-500 text-slate-800 mb-2"
              : "text-lg mt-5 font-semibold text-gray-500 text-slate-800 mb-2"
          }
        >
          Token Price
        </h2>
        <div
          className={
            isMobile ? "flex items-center justify-center" : "flex items-start"
          }
        >
          <div className="flex">
            <div className="text-4xl flex font-bold text-slate-800 mr-2">
              <AiFillDollarCircle
                style={{
                  backgroundImage:
                    "linear-gradient(120deg, #d4fc79 0%, #96e6a1 100%)",
                  width: "45px",
                  height: "45px",
                  padding: "6px",
                  borderRadius: "15px",
                }}
                className="text-green-800"
              />{" "}
              <span className="ml-5">
                {greenTokenDetails.tokenPrice && greenTokenDetails.tokenPrice}
              </span>
              <span className="text-lg mt-4 ml-1">
                {greenTokenDetails.symbol && greenTokenDetails.symbol}
              </span>
            </div>
            <div className="text-4xl flex font-bold ml-4 text-slate-800 mr-2">
              <AiFillDollarCircle
                style={{
                  backgroundImage:
                    "linear-gradient(120deg, #83EAF1 0%, #63A4FF 100%)",
                  width: "45px",
                  height: "45px",
                  padding: "6px",
                  borderRadius: "15px",
                }}
                className="text-blue-800"
              />{" "}
              <span className="ml-5">
                {blueTokenDetails.tokenPrice && blueTokenDetails.tokenPrice}
              </span>
              <span className="text-lg mt-4 ml-1">
                {" "}
                {blueTokenDetails.symbol && blueTokenDetails.symbol}
              </span>
            </div>
          </div>
          {/* <div className="text-sm font-semibold text-white px-1.5 bg-green-500 rounded-full">
            +49%
          </div> */}
        </div>
        <h2
          className={
            isMobile
              ? "text-lg text-center mt-5 font-semibold text-gray-500 text-slate-800 mb-2"
              : "text-lg mt-5 font-semibold text-gray-500 text-slate-800 mb-2"
          }
        >
          Circulating Supply
        </h2>
        <div
          className={
            isMobile ? "flex items-center justify-center" : "flex items-start"
          }
        >
          <div className="flex">
            {greenTokenDetails.circulating !== "N/A" ? (
              <div className="text-4xl flex font-bold text-slate-800 mr-2">
                <MdOutlineGeneratingTokens
                  style={{
                    backgroundImage:
                      "linear-gradient(120deg, #d4fc79 0%, #96e6a1 100%)",
                    width: "45px",
                    height: "45px",
                    padding: "6px",
                    borderRadius: "15px",
                  }}
                  className="text-green-800"
                />{" "}
                <span className="ml-5">
                  {greenTokenDetails.circulating &&
                    greenTokenDetails.circulating}
                </span>
                <span className="text-lg mt-4 ml-1">
                  {" "}
                  {greenTokenDetails.symbol && greenTokenDetails.symbol}
                </span>
              </div>
            ) : (
              <Skeleton />
            )}
            {blueTokenDetails.circulating !== "N/A" ? (
              <div className="text-4xl flex font-bold ml-4 text-slate-800 mr-2">
                <MdOutlineGeneratingTokens
                  style={{
                    backgroundImage:
                      "linear-gradient(120deg, #83EAF1 0%, #63A4FF 100%)",
                    width: "45px",
                    height: "45px",
                    padding: "6px",
                    borderRadius: "15px",
                  }}
                  className="text-blue-800"
                />{" "}
                <span className="ml-5">
                  {blueTokenDetails.circulating && blueTokenDetails.circulating}
                </span>
                <span className="text-lg mt-4 ml-1">
                  {blueTokenDetails.symbol && blueTokenDetails.symbol}
                </span>
              </div>
            ) : (
              <div className="ml-4">
                <Skeleton />
              </div>
            )}
          </div>
          {/* <div className="text-sm font-semibold text-white px-1.5 bg-green-500 rounded-full">
            +49%
          </div> */}
        </div>
        <h2
          className={
            isMobile
              ? "text-lg text-center mt-5 font-semibold text-gray-500 text-slate-800 mb-2"
              : "text-lg mt-5 font-semibold text-gray-500 text-slate-800 mb-2"
          }
        >
          Total Tokens
        </h2>
        <div
          className={
            isMobile ? "flex items-center justify-center" : "flex items-start"
          }
        >
          <div className="flex">
            {greenTokenDetails.totalTokens !== "N/A" ? (
              <div className="text-4xl mb-5 flex font-bold text-slate-800 mr-2">
                <BiCoinStack
                  style={{
                    backgroundImage:
                      "linear-gradient(120deg, #d4fc79 0%, #96e6a1 100%)",
                    width: "45px",
                    height: "45px",
                    padding: "6px",
                    borderRadius: "15px",
                  }}
                  className="text-green-800"
                />{" "}
                <span style={{ fontSize: "48px" }} className="ml-5">
                  {greenTokenDetails.totalTokens &&
                    greenTokenDetails.totalTokens}
                </span>
                <span className="text-lg mt-4 ml-1">
                  {greenTokenDetails.symbol && greenTokenDetails.symbol}
                </span>
              </div>
            ) : (
              <Skeleton />
            )}
            {blueTokenDetails.totalTokens !== "N/A" ? (
              <div className="text-4xl mb-5 flex font-bold ml-4 text-slate-800 mr-2">
                <BiCoinStack
                  style={{
                    backgroundImage:
                      "linear-gradient(120deg, #83EAF1 0%, #63A4FF 100%)",
                    width: "45px",
                    height: "45px",
                    padding: "6px",
                    borderRadius: "15px",
                  }}
                  className="text-blue-800"
                />{" "}
                <span className="ml-5">
                  {blueTokenDetails.totalTokens && blueTokenDetails.totalTokens}
                </span>
                <span className="text-lg mt-4 ml-1">
                  {blueTokenDetails.symbol && blueTokenDetails.symbol}
                </span>
              </div>
            ) : (
              <div className="ml-4">
                <Skeleton />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Stat1;
